const STORAGE_PREFIX = "generic_table_hidden_columns:";

const storageKey = (tableName: string) => `${STORAGE_PREFIX}${tableName}`;

export const readHiddenColumns = (tableName: string): string[] | null => {
    try {
        const raw = window.localStorage.getItem(storageKey(tableName));
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return null;
        return parsed.filter((key): key is string => typeof key === "string");
    } catch {
        return null;
    }
};

export const writeHiddenColumns = (
    tableName: string,
    hiddenKeys: Set<string> | string[],
) => {
    try {
        window.localStorage.setItem(
            storageKey(tableName),
            JSON.stringify(Array.from(hiddenKeys)),
        );
    } catch {
        // quota / private mode
    }
};
